'use client';

import { useState } from 'react';

import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';
import { StrategyPageMainPanelTab } from '@strategyProfile/components/StrategyPageMain/Panels/MainPanel/strategyPageMainPanelTab';
import { useTranslations } from 'next-intl';

import { PublicStrategy } from '@/api/copy-trading/types';
import tabsStyles from '@/blocks/components/Controls/Tabs/styles.module.scss';
import { DeprecatedTabsOverflowContainer } from '@/blocks/components/DeprecatedTabs';

import { Panel } from '../../Components/Panel';
import styles from './styles.module.scss';

type MainPanelProps = {
  mainPanelTabs: { [key in StrategyPageMainPanelTab]?: React.ReactNode };
  strategy: PublicStrategy;
};

export function MainPanel({ strategy, mainPanelTabs }: MainPanelProps) {
  const [selectedTab, setSelectedTab] = useState(StrategyPageMainPanelTab.TRADING_DATA);
  const tr = useTranslations();

  return (
    <Panel className={styles.mainPanel} innerContentMaxWidthDesktop={702}>
      <DeprecatedTabsOverflowContainer className={styles.tabsContainer}>
        <Tabs
          value={selectedTab}
          onChange={(_, tab) => setSelectedTab(tab)}
          scrollButtons={false}
          className={tabsStyles.tabs}
          variant={'scrollable'}
        >
          <Tab
            value={StrategyPageMainPanelTab.TRADING_DATA}
            disableRipple
            label={tr.rich('pages.strategyPage.sections.main.widgets.main.tabs.tradingData.label')}
          />
          <Tab
            value={StrategyPageMainPanelTab.TRADING_HISTORY}
            disableRipple
            label={tr.rich('pages.strategyPage.sections.main.widgets.main.tabs.tradingHistory.label')}
          />
        </Tabs>
      </DeprecatedTabsOverflowContainer>
      {mainPanelTabs[selectedTab]}
    </Panel>
  );
}
